import { jsx as _jsx } from "react/jsx-runtime";
import { Loading, Modal } from "@ting/ting-ui-components";
import { classNameFactory } from "@src/utils/dom";
import "./fullScreenLoading.scss";
const cn = classNameFactory("full-screen-loading");
export const FullScreenLoading = () => {
    return (_jsx(Modal, { fullscreen: true, scrollable: false, hideCloseButton: true, className: cn(""), containerClassName: cn("flex"), children: _jsx(Loading, {}) }));
};
